exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".packDetail .el-col[data-v-8a5e382c]{margin:10px 0}\n", ""]);

// exports
